export default __webpack_public_path__ + "static/media/powerpoint.0391fdd5.svg";